import { ICursor } from '@/store/types/search.types';
import { TAppError } from '@/store/types/base.state';

export type TRestrictionsGroupType = 'mid' | 'mcc' | 'country';

export const restrictionsGroupIdProps: Record<TRestrictionsGroupType, string> = {
  mcc: 'mccRestrictionGroupId',
  mid: 'merchantRestrictionGroupId',
  country: 'countryRestrictionGroupId',
};

export const errorMessages: Record<TRestrictionsGroupType, string> = {
  mcc: 'Please review your input, data must be a list of 4-digit numbers for MCC list',
  mid: 'Please review your input, for MID list data must be 1 to 15 characters long ; authorised characters : A to Z, 0 to 9, [$%&*]',
  country: 'Please review your input, countries data must have ISO 3166‑1 alpha‑2 format',
};

export interface IRestrictionsGroupMetadata {
  mid: string | number;
  [key: string]: string | number;
}

export type TRestrictionsGroupMetadataValue = Record<string, string | number>;
export type TRestrictionsGroupMetadataFile = Record<string, Record<string | number, string | number>>;

export enum RestrictionsGroupStatus {
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  VALIDATED = 'VALIDATED',
}

export interface IBaaSRestrictionsGroup {
  createdDate?: string;
  modifiedDate?: string;
  id?: number;
  isWhitelist: boolean;
  name: string;
  startDate: string;
  status?: RestrictionsGroupStatus;
}

export const restrictionsGroupIdTypes = {
  mcc: 'mccRestrictionGroups',
  mid: 'merchantIdRestrictionGroups',
  country: 'countryRestrictionGroups',
} as const;

export interface IPAginateBaaSRestrictionGroup {
  merchantIdRestrictionGroups?: IBaaSRestrictionsGroup[];
  mccRestrictionGroups?: IBaaSRestrictionsGroup[];
  countryRestrictionGroups?: IBaaSRestrictionsGroup[];
  meta?: {
    maxPerPage: number;
    pageNumber: number;
    totalPages: number;
    totalResults: number;
  };
}

export interface IMccRestrictionsGroup extends IBaaSRestrictionsGroup {
  mcc: number[];
  type: 'mcc';
}

export interface ICountryRestrictionsGroup extends IBaaSRestrictionsGroup {
  countries: string[];
  type: 'country';
}

export interface IMidRestrictionsGroup extends IBaaSRestrictionsGroup {
  merchants: string[];
  type: 'mid';
}

export interface IRestrictionsGroup extends IBaaSRestrictionsGroup {
  type: TRestrictionsGroupType;
  restrictions: (string | number)[];
}

export interface IStateRestrictionsGroup {
  group: IRestrictionsGroup;
  metadata?: IRestrictionsGroupMetadata[];
  isLoading?: boolean;
  error?: TAppError;
  cursor?: ICursor;
}

export interface IRestrictionsGroupForm {
  name: string;
  startDate: string;
  isWhitelist: string;
  restrictions: (string | number)[];
  extendsRestrictionsGroupId?: number;
}

export interface ISearchRestrictionsGroupService {
  type: TRestrictionsGroupType;
  restrictionsGroupId?: number;
  currentPage: number;
  pageCount: number;
  filters?: IFilter[];
}

export interface IFilter {
  fieldName: keyof Omit<IBaaSRestrictionsGroup, 'modifiedDate'>;
  criteria: '>' | '>=' | '<' | '<=' | '!=' | 'like' | 'in' | '==';
  expression: string;
}

interface IPagination {
  currentPage?: number;
  pageCount?: number;
}

export interface ISearchPredefRestrictionsGroups extends IPagination {
  types: TRestrictionsGroupType[];
  groupId?: number;
  filters?: IFilter[];
}
